const langtrans={
      ajgzzz:["案件工作台","Case worktable"],
      wwddqa:["为当前案件加入星使","为当前案件加入星使"],
      qsr:["请输入","Please enter"],
      ffs:["发送","Send"],
      gzzztt:["工作台人员","Worktable staff"],
      dtc:["弹窗","pop up"],
      yhxsxx:["用户信息","en_translated"],
      gb:["关闭","closed"],
      ljydks:["连接已断开，是否重新连接","You have been dsiconnected. Do you want to reconnect?"],
      ffsnrb:["发送内容不能为空","The content cannot be empty"],
}
export default langtrans;


// WEBPACK FOOTER //
// ./src/views/commonPage/js/workbench.vue.trans.js